export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/DxfViewerWorker.8cda7998.worker.js");
}
